/**
 * Invite Modal helper functions
 */

/**
 * Filter manual emails based on search query
 */
export function filterManualEmails(
  emails: Set<string>,
  searchQuery: string
): string[] {
  return Array.from(emails).filter((email) => {
    if (!searchQuery.trim()) return true;
    return email.toLowerCase().includes(searchQuery.toLowerCase());
  });
}

/**
 * Get send button text based on selected count
 */
export function getSendButtonText(selectedCount: number): string {
  return `Send ${selectedCount} Invitation${selectedCount !== 1 ? 's' : ''}`;
}
